import React from 'react';
// import FontAwesome5 from '@expo/vector-icons/FontAwesome5';
// import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import { IconSvg } from 'src/assets';
import { TripDetailProps } from 'src/common/api/response';
import { formatDate } from 'src/common/utils/DateHelper';
import { Container, NewAmenities, Operator, RegularText, Row, SizedBox, TripLabelValue } from 'src/components';
import { Navigation } from 'src/navigations/RootNavigation';
import { AppColors } from 'src/themes/Colors';
import { metrics, pixelScaler } from 'src/themes/Metrics';
import { TimeLine } from '../Timeline';
import { AboutTripContent } from './AboutTripContent';

export const BoardingContent = ({
  tripDetail,
  onCloseModal,
}: {
  tripDetail: TripDetailProps;
  onCloseModal?: () => void;
}) => {
  const { t } = useTranslation();
  // const [showMore, setShowMore] = React.useState<boolean>(false);
  // const [data, setData] = React.useState<any[]>([]);
  // console.log(setData);

  // React.useEffect(() => {
  //   let finalData = [transits[0], transits[transits.length - 1]];
  //   if (showMore) {
  //     finalData = transits;
  //   }

  //   setData([...finalData]);
  //   return () => {};
  // }, [showMore]);

  return (
    <ScrollView contentContainerStyle={{ padding: metrics.large }}>
      <Row marginBottom={metrics.large} style={{ justifyContent: 'space-between' }}>
        <Operator showRating={false} busService={tripDetail.service} operator={tripDetail.operator} />
        <Container width={80}>
          <TripLabelValue labelAlign="left" label="from" value={`$ ${tripDetail.price}`} />
        </Container>
      </Row>

      <Row marginBottom={metrics.medium} style={{ width: '100%', justifyContent: 'space-between' }}>
        <Container flex>
          <TripLabelValue
            label="dateAndTime"
            value={
              <Row middle>
                <RegularText fontWeight="bold">{formatDate(new Date())} </RegularText>
                <RegularText style={{ paddingBottom: metrics.tiny }} color={AppColors.lighterGray}>
                  {'  '}|{'  '}
                </RegularText>
                <RegularText fontWeight="bold">{tripDetail.departureTime} </RegularText>
              </Row>
            }
          />
        </Container>
        <Container width={80}>
          <TripLabelValue labelAlign="left" label="duration" value={tripDetail.duration} />
        </Container>
      </Row>

      <Divider style={{ marginTop: metrics.medium, marginBottom: metrics.large }} />

      {/* <Row style={{ justifyContent: 'space-between', alignItems: 'center' }} width="100%">
        <RegularText textLang="directTrip" />

        {showMore ? (
          <Button
            style={{
              textTransform: 'none',
              fontSize: fontSizes.medium,
            }}
            color="info"
            variant="text"
            onClick={() => setShowMore(false)}>
            {t('seeLess')}
          </Button>
        ) : (
          <Button
            style={{
              textTransform: 'none',
              fontSize: fontSizes.medium,
            }}
            color="info"
            variant="text"
            onClick={() => setShowMore(true)}>
            {t('seeMore')}
          </Button>
        )}
      </Row> */}

      {/* <Container> */}
      <TimeLine transits={tripDetail.transits} />
      <Divider style={{ marginBottom: metrics.large }} />
      <NewAmenities amenities={tripDetail.amenities} />
      <Divider style={{ marginTop: metrics.large, marginBottom: metrics.large }} />
      {!tripDetail.instantBooking && (
        <>
          <Row middle marginBottom={metrics.medium}>
            <RegularText fontSize="large" fontWeight="bold" color={AppColors.darkerOrange}>
              {t('instantBooking')}
            </RegularText>
            <IconSvg.Lighning />
          </Row>
          <RegularText>{tripDetail.instantBookingMessage.replace('\n', '').trim()}</RegularText>
          <RegularText>{tripDetail.instantBookingMessage}</RegularText>
        </>
      )}
      <TouchableOpacity
        activeOpacity={0.8}
        onPress={() => {
          if (onCloseModal) onCloseModal();
          Navigation.navigate('CancellationPolicyScreen');
        }}>
        <Row middle>
          <RegularText
            style={{ textDecorationLine: 'underline' }}
            fontSize="large"
            fontWeight="bold"
            color={AppColors.red}
            textLang="cancellationPolicy"
          />
          <SizedBox width="small" />
          <IconSvg.ArrowRight fill={AppColors.red} />
        </Row>
      </TouchableOpacity>
      {/* <CancellationPolicyContent /> */}
      <SizedBox height={pixelScaler(20)} />
      <AboutTripContent data={tripDetail.tripInfo} />
      {/* </Container> */}
    </ScrollView>
  );
};
